import Image from "next/image";
import Link from "next/link";
import { useIntl } from "react-intl";
import dayjs from "dayjs";
import {
  addBasePathToStrapiMedia,
  formatStrapiEntity,
  StrapiEntity,
  StrapiImage,
} from "@/utils/strapi";
import { injectPurifiedHTML } from "@/utils/injectPurifiedHTML";
import { removeEmptyRel } from "@/utils/removeEmptyRel";
import styles from "./DescriptiveBlock.module.scss";

export type DescriptiveBlockProps = {
  title: string;
  description: string | null;
  image: StrapiEntity<StrapiImage>;
  url: string | null;
  date: string | null;
};

export const DescriptiveBlock = ({
  title,
  description,
  image,
  url,
  date,
}: DescriptiveBlockProps) => {
  const strapiImage = formatStrapiEntity(image);
  const intl = useIntl();

  return (
    <div className={styles.container}>
      <div className={styles.imageContainer}>
        <Image
          src={addBasePathToStrapiMedia(strapiImage)}
          objectFit="contain"
          objectPosition="center"
          alt={strapiImage.alternativeText ?? ""}
          layout="fill"
        />
      </div>
      <div className={styles.article}>
        {date !== null && (
          <div className={styles.date}>{dayjs(date).format("DD/MM/YYYY")}</div>
        )}
        <div className={styles.title}>{title}</div>
        {description !== null && (
          <div
            className={styles.description}
            dangerouslySetInnerHTML={injectPurifiedHTML(
              removeEmptyRel(description)
            )}
          />
        )}
        {url !== null && (
          <Link href={url}>
            <a className={styles.knowMore}>
              {intl.formatMessage({ id: "knowMore" })}
            </a>
          </Link>
        )}
      </div>
    </div>
  );
};
